import { visit } from "unist-util-visit";

export function lineBreaks() {
  return (tree) => {
    const replacements = [];
    visit(tree, "text", (node, index, parent) => {
      if (!parent || typeof node.value !== "string") return;
      if (!node.value.includes("\n")) return;

      const parts = node.value.split("\n");
      const newNodes = [];

      parts.forEach((part, i) => {
        if (part.length) newNodes.push({ type: "text", value: part });
        if (i !== parts.length - 1) newNodes.push({ type: "break" });
      });

      replacements.push({ parent, index, newNodes });
    });

    for (let i = replacements.length - 1; i >= 0; i--) {
      const { parent, index, newNodes } = replacements[i];
      parent.children.splice(index, 1, ...newNodes);
    }

    if (tree && Array.isArray(tree.children)) {
      const newChildren = [];
      for (let i = 0; i < tree.children.length; i++) {
        const curr = tree.children[i];
        newChildren.push(curr);

        const next = tree.children[i + 1];
        if (
          next &&
          curr.position &&
          next.position &&
          curr.position.end &&
          next.position.start
        ) {
          const gap = next.position.start.line - curr.position.end.line;
          if (gap >= 2) {
            for (let k = 0; k < gap - 1; k++) {
              newChildren.push({
                type: "paragraph",
                children: [{ type: "break" }],
              });
            }
          }
        }
      }
      tree.children = newChildren;
    }
  };
}
